import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    Collapse,
    IconButton,
    TableRow, Typography, TableCell, Table, TableBody
} from '@material-ui/core';
import StyledTableCell from '../TableCell';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

class PricePaidRow extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        uprn: PropTypes.string.isRequired,
        pricePaid: PropTypes.array.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            isCollapsed: true
        };

        this.toggleCollapsed = this.toggleCollapsed.bind(this);
    }

    toggleCollapsed () {
        this.setState({
            isCollapsed: !this.state.isCollapsed
        });
    }

    render () {
        const { classes, uprn, pricePaid } = this.props;
        const { isCollapsed } = this.state;
        const defaultPricePaid = pricePaid[0];
        const additionalPricePaid = pricePaid.slice(1);
        return (
            <>
                <TableRow>
                    <StyledTableCell className={additionalPricePaid.length > 0 && classes.dropdownTableCell} width="30%">
                        { additionalPricePaid.length > 0 && <IconButton
                            className={classes.iconButton}
                            onClick={this.toggleCollapsed}
                        >
                            {isCollapsed ? <ArrowRightIcon /> : <ArrowDropDownIcon />}
                        </IconButton>}
                        {uprn}
                    </StyledTableCell>
                    <StyledTableCell width="30%">
                        <Typography variant="caption" className={classes.chip}>
                            {defaultPricePaid.propertyType}
                        </Typography>
                    </StyledTableCell>
                    <StyledTableCell width="20%">
                        £{defaultPricePaid.price.toLocaleString()}
                    </StyledTableCell>
                    <StyledTableCell width="20%">
                        {defaultPricePaid.dateOfTransfer}
                    </StyledTableCell>
                </TableRow>
                {additionalPricePaid.length > 0 && <TableRow>
                    <TableCell className={classes.collapsibleTableCell} colSpan={4}>
                        <Collapse in={!isCollapsed} timeout="auto" unmountOnExit>
                            <Table>
                                <TableBody>
                                    {
                                        additionalPricePaid.map(e => <TableRow key={e.id}>
                                            <StyledTableCell
                                                className={additionalPricePaid.length > 0 && classes.dropdownTableCell}
                                                width="60%"
                                                colSpan={2}
                                            />
                                            <StyledTableCell width="20%">
                                            £{e.price.toLocaleString()}
                                            </StyledTableCell>
                                            <StyledTableCell width="20%">
                                                {e.dateOfTransfer}
                                            </StyledTableCell>
                                        </TableRow>)
                                    }
                                </TableBody>
                            </Table>
                        </Collapse>
                    </TableCell>
                </TableRow>}
            </>
        );
    }
}

const style = theme => ({
    chip: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 5,
        padding: '0px 5px',
        height: 16,
        color: '#D6D6FF',
        backgroundColor: '#D6D6FF33'
    },
    dropdownTableCell: {
        paddingLeft: '0 !important'
    },
    collapsibleTableCell: {
        padding: '0 !important',
        borderBottom: 'initial'
        // height: theme.constants.tableRowHeight,
    },
    iconButton: {
        padding: '0 !important'
    }
});

export default withStyles(style)(PricePaidRow);